import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import { Link, useParams } from "react-router-dom";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { toJalali } from "lib/helpers";
import ListFilter from "components/list/ListFilter";
export default function CafeTickets() {
  const { plan_id, plan_name } = useParams();
  const path = {
    baseRoute: `/cafe-tickets/${plan_id}`,
    aliasName: "بیلت های کافه",
    type: "CafeTickets",
  };

  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    createAndDownload,
    remove,
    listSearch,
    from,
    to,
    meta,
    total,
  } = useList();

  const [showAdd, setShowAdd] = useState(false);
  const [item, setItem] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  useEffect(() => {
    dispatch(getList(path));

    return () => {
      dispatch(clear());
    };
  }, []);

  const filterItems = [
    {
      type: "TEXT",
      name: "_search",
      label: "جستجو",
    },
    {
      type: "DATE_FROM_TO",
    },
  ];

  return (
    <>
      <Delete
        title="حذف بلیت"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item.id, () => {
              handleSuccessMessages("بلیت مورد نظر با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">
          بلیت های {plan_name}
        </h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <ListFilter path={path} items={filterItems} hasExcelReport />
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">کد</th>
                  <th className="whitespace-nowrap text-center">برچسب</th>

                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  <th className="whitespace-nowrap text-center">ایجاد کننده</th>
                  <th className="whitespace-nowrap text-center">
                    استفاده کننده
                  </th>
                  <th className="whitespace-nowrap text-center">تاریخ صدور</th>

                  <th className="whitespace-nowrap text-center">تاریخ انقضا</th>

                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item, index) => (
                    <tr key={`item_${index}`} className="intro-x">
                      <td className="text-center">{item.code}</td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.tag}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.used ? "استفاده شده" : "استفاده نشده"}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.creator && item.creator.full_name}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.user && item.user.full_name}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.created_at &&
                            toJalali(item.created_at, "jYYYY-jMM-jDD HH:mm")}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.expire_date &&
                            toJalali(item.expire_date, "jYYYY-jMM-jDD HH:mm")}
                        </p>
                      </td>

                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          <a
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1 " />
                            حذف{" "}
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
